import { useEffect, useRef, useState } from "react";
import { MessageCircle, X, Send, Loader2, Bot } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const sessionId = () => {
  let s = localStorage.getItem("aces_chat_session");
  if (!s) {
    s = `s${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("aces_chat_session", s);
  }
  return s;
};

const WELCOME = { role: "assistant", text: "Bonjour et bienvenue chez Aces Service ! Comment puis-je vous aider ? Je peux vous présenter nos services ou vous établir un devis de formation." };

export const ChatWidget = () => {
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState(() => JSON.parse(localStorage.getItem("aces_chat_msgs") || "null") || [WELCOME]);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const end = useRef(null);

  useEffect(() => {
    localStorage.setItem("aces_chat_msgs", JSON.stringify(msgs.slice(-30)));
    end.current?.scrollIntoView({ behavior: "smooth" });
  }, [msgs, open]);

  const send = async (e) => {
    e.preventDefault();
    const t = text.trim();
    if (!t || loading) return;
    setMsgs((m) => [...m, { role: "user", text: t }]);
    setText("");
    setLoading(true);
    try {
      const r = await api.post("/public/chat", { session_id: sessionId(), message: t });
      setMsgs((m) => [...m, { role: "assistant", text: r.data.reply }]);
    } catch (err) {
      setMsgs((m) => [...m, { role: "assistant", text: errMsg(err) }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed bottom-5 right-5 z-50">
      {open && (
        <div className="mb-3 flex h-[32rem] w-[calc(100vw-2.5rem)] max-w-sm flex-col overflow-hidden rounded-md border border-slate-200 bg-white shadow-2xl fade-up" data-testid="chat-panel">
          <div className="flex items-center justify-between bg-[#0F172A] px-4 py-3 text-white">
            <div className="flex items-center gap-2"><Bot className="h-5 w-5 text-red-400" /><div><p className="text-sm font-semibold">Assistant Aces Service</p><p className="text-[10px] text-slate-400">Réponse automatique par IA</p></div></div>
            <button onClick={() => setOpen(false)} data-testid="chat-close-btn"><X className="h-4 w-4" /></button>
          </div>
          <div className="flex-1 space-y-3 overflow-y-auto bg-slate-50 p-4" data-testid="chat-messages">
            {msgs.map((m, i) => (
              <div key={i} className={`max-w-[85%] whitespace-pre-line rounded-md px-3 py-2 text-sm ${m.role === "user" ? "ml-auto bg-red-600 text-white" : "bg-white text-slate-800 shadow-sm"}`}>{m.text}</div>
            ))}
            {loading && <div className="flex w-fit items-center gap-2 rounded-md bg-white px-3 py-2 text-xs text-slate-500 shadow-sm" data-testid="chat-typing"><Loader2 className="h-3 w-3 animate-spin" /> L'assistant rédige…</div>}
            <div ref={end} />
          </div>
          <form onSubmit={send} className="flex gap-2 border-t border-slate-200 p-3">
            <input value={text} onChange={(e) => setText(e.target.value)} maxLength={1500} placeholder="Écrivez votre message…" className="h-10 flex-1 rounded-md border border-slate-200 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-900/30" data-testid="chat-input" />
            <button type="submit" disabled={loading} className="flex h-10 w-10 items-center justify-center rounded-md bg-red-600 text-white hover:bg-red-700 disabled:opacity-50" data-testid="chat-send-btn"><Send className="h-4 w-4" /></button>
          </form>
        </div>
      )}
      <button onClick={() => setOpen(!open)} className="ml-auto flex h-14 w-14 items-center justify-center rounded-full bg-red-600 text-white shadow-xl transition-transform hover:scale-105" data-testid="chat-toggle-btn" aria-label="Ouvrir le chat">
        {open ? <X className="h-6 w-6" /> : <MessageCircle className="h-6 w-6" />}
      </button>
    </div>
  );
};
